import React, {MouseEvent} from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  background: ${props => props.background};
  color: ${props => props.color};
  font-size: 15px;
  font-weight: 500;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: center;
  transition: all 300ms;
  display: ${props => props.display || "block"};
  border: ${props => props.border ? `1px solid ${props.border};` : `1px solid transparent`} ${props => !props.miniSized && `width: 200px;`}
  margin: ${props => props.centered ? `10px auto;` : `10px 10px 0 0;`}
  &:hover {
    opacity: 0.9;
    cursor: pointer;
  }
`;

type ButtonProps = {
    background: string;
    color: string;
    onClick: (event: MouseEvent<HTMLDivElement>) => void;
    text: string;
    centered?: boolean;
    miniSized?: boolean;
    onMouseDown?: () => void;
    display?: string;
    border?: string;
    marginRight?: string;
};


const Button: React.FC<ButtonProps> = ({
                                           background,
                                           color,
                                           onClick,
                                           text,
                                           centered,
                                           miniSized,
                                           onMouseDown,
                                           display,
                                           border,
                                           marginRight
                                       }) => {
    return (
        <StyledDiv
            background={background}
            color={color}
            onClick={onClick}
            onMouseDown={onMouseDown}
            centered={centered}
            miniSized={miniSized}
            display={display}
            border={border}
            marginRight={marginRight}
        >
            {text}
        </StyledDiv>
    );
};

export default Button;